<template>
  <div class="booking-form">
    <div class="panel panel-send-request" v-if="$campaigns && $userIsAdmin">
      <div class="panel-body">
        <h3>Assign to campaign</h3>
        <div class="flex w-full margin-t-4">
          <div class="w-3/4 margin-r-2">
            <selectize
              name="campaign"
              ref="campaigns"
              class="selectize selectize-single w-full"
              :options="campaignOptions"
              :fetch-results="getCampaigns"
              :fetch-more-results="getNextCampaigns"
              placeholder="None"
              v-model="$v.campaign_id.$model">
            </selectize>
          </div>
          <button :disabled="!campaign_id" @click="() => { this.campaign_id = null }" class="btn btn-md btn-default flex-shrink-0">Remove from campaign</button>
        </div>
      </div>
    </div>
    <div class="panel panel-send-request">
      <div class="panel-body">
        <h3>{{ $t('your deliverables') | sentenceCase }}</h3>

        <hr />

        <div :class="hasErrorClass($v.name, 'form-group')">
          <label class="control-label">* {{ $t('request_stars.request_name') }}</label>

          <input
            name="name"
            type="text"
            class="form-control"
            :placeholder="$tc('request_stars.activity_example') "
            v-model="$v.name.$model" />

          <vuelidate-help :field="$v.name" :label="'Name'" />
        </div>

        <div :class="hasErrorClass($v.category, 'form-group')" v-if="$categoryModuleEnabled">
          <label class="control-label">* {{ $t('Request Category') }}</label>

          <selectize
            key="category"
            class="selectize selectize-single"
            name="category_id"
            v-model="$v.category.$model"
            :options="categoryOptions"
          />

          <vuelidate-help :field="$v.category" :label="$t('Category')"/>
        </div>

        <div :class="hasErrorClass($v.department_id, 'form-group')" v-if="$showDepartmentField && ($userIsAdmin || ($userIsClient && $clientDepartment))">
          <label class="control-label">* {{ $t('requesting department') | titleCase }}</label>
          <department-selection :model="$v.department_id" :additional-departments="additionalDepartments" :show-label="false" :default="booking.department" :restricted_departments_only="$userIsClient && $clientDepartment"/>
        </div>

        <booking-field-input
          v-if="$isNflClient && $vlastMode"
          :classes="hasErrorClass($v.nfl_event_type, 'form-group')"
          :booking="booking"
          :property-mutator="propertyMutator"
          style="text-transform: capitalize"
          field="nfl_event_type"
          field-type="select"
          :options="nflEventTypeOptions"
          :validations="$v.nfl_event_type"
          label="* NFL Event"/>

        <booking-field-input
          v-if="!$vlastMode"
          :classes="hasErrorClass($v.segment, 'form-group')"
          :booking="booking"
          :property-mutator="propertyMutator"
          style="text-transform: capitalize"
          field="segment"
          field-type="select"
          :options="segmentOptions"
          :validations="$v.segment"
          label="* Segment"/>
        <booking-field-input
          v-if="!$vlastMode && booking.segment === 'agency'"
          :classes="hasErrorClass($v.agency_stage, 'form-group')"
          :booking="booking"
          :property-mutator="propertyMutator"
          field="agency_stage"
          :validations="$v.agency_stage"
          field-type="select"
          :options="agencyStageOptions"
          :value="findAgencyStageText"
          :other-classes="hasErrorClass($v.other_agency_stage, 'form-group')"
          other-field="other_agency_stage"
          :other-validations="$v.other_agency_stage"
          label="* Agency Stage"/>

        <div v-if="!$vlastMode && booking.segment !== 'fan'" :class="hasErrorClass($v.organisation_name, 'form-group')">
          <label class="control-label">{{ $t('organisation') | sentenceCase }} Name</label>

          <input
            name="name"
            type="text"
            class="form-control"
            v-model="$v.organisation_name.$model" />

          <vuelidate-help :field="$v.organisation_name" v-bind:label="$t('organisation') + ' Name' | sentenceCase" />
        </div>

        <booking-field-input
          :classes="hasErrorClass($v.opportunities, 'form-group')"
          :validations="$v.opportunities"
          :booking="booking" :property-mutator="propertyMutator"
          field="opportunities"
          field-type="multi-select"
          :multi-select-types="['appearance_type', 'theme', 'event_type', 'opportunity_type']"
          :label="'* ' + $t('Event Summary')"/>

      <!-- TODO: Booking custom fields CU-3judex-->
        <div v-if="clientName === 'auscricket'" class="row">
          <div class="col-md-6">
            <booking-field-input
              :classes="hasErrorClass($v.aca_event_location, 'form-group')"
              :booking="booking"
              :property-mutator="propertyMutator"
              style="text-transform: capitalize"
              field="aca_event_location"
              field-type="select"
              :options="acaLocationOptions"
              :validations="$v.aca_event_location"
              :label="'* ' + $t('Request') + ' Details'"/>
          </div>
          <div class="col-md-6">
            <booking-field-input
              :classes="hasErrorClass($v.aca_event_gender, 'form-group')"
              :booking="booking"
              :property-mutator="propertyMutator"
              style="text-transform: capitalize"
              field="aca_event_gender"
              field-type="select"
              :options="acaGenderOptions"
              :validations="$v.aca_event_gender"
              label="* Event Gender"/>
          </div>
          <div v-if="this.aca_event_location === 'Regional Event (100kms from CBD)'" class="col-md-6" :class="hasErrorClass($v.aca_event_distance, 'filter form-group')">
            <label class="control-label">* Approximate distance from CBD</label>
            <div class="input-group">
              <input
                name="aca_event_distance"
                v-model="$v.aca_event_distance.$model"
                class="form-control"
              />
            </div>
          </div>
        </div>
<!--        TODO: Booking custom fields CU-3judex-->

        <div class="row">
          <div class="col-md-6">
            <div class="form-group">
              <label class="control-label">Appearance Type</label>
              <input
                name="appearance_type"
                type="text"
                class="form-control"
                disabled
                v-model="displayAppearanceType" />
            </div>
          </div>
          <div class="col-md-6" v-if="showOnlineBooking">
            <div v-if="!$vlastMode" :class="hasErrorClass($v.complete_by_date, 'form-group calendar-group')">
              <label class="control-label"><span v-if="!$vlastMode">*</span>Online Deliverables Complete By Date</label>
              <flat-pickr
                v-model="$v.complete_by_date.$model"
                :config="flatPickerSingleDateConfig"
                class="form-control pickdate"
                placeholder="Please select a date"
                name="complete_by_date"/>

              <vuelidate-help :field="$v.complete_by_date" :label="'Complete By Date'" :custom-messages="{ 'insideDateBounds': selectCampaignOptionErrorMessage }" />

              <info-alert v-if="showCriticalChangeWarnings" :type="'warning'" :message="`Changing the date(s) will notify ${$starLabelPlural} and require them to re-apply`" />
            </div>
            <div v-else :class="hasErrorClass($v.video_url, 'form-group')">
              <label class="control-label">Video URL</label>
              <input
                name="video_url"
                type="text"
                class="form-control"
                v-model="$v.video_url.$model" />

              <vuelidate-help :field="$v.video_url" :label="'Video URL'" />
            </div>
          </div>
          <div class="col-md-6" v-if="showOnlineBooking">
            <div :class="hasErrorClass($v.duration, 'form-group calendar-group')">
              <label class="control-label">Duration</label>

              <selectize
                name="duration"
                class="selectize selectize-single"
                placeholder="Please select"
                v-model="$v.duration.$model"
                :options="opportunityDurationOptions"/>
                <vuelidate-help :field="$v.duration" :label="'Duration'" />
            </div>
          </div>
        </div>
        <template>
          <div class="row">
            <div class="col-md-6" v-if="showInPersonBooking || ($vlastMode && showOnlineBooking) || ($vlastMode && $offersModuleEnabled)">
              <div :class="hasErrorClass($v.date, 'form-group calendar-group')">
                <label class="control-label" v-if="$vlastMode && $isOtis">* {{ $t('Request') }} Date</label>
                <label class="control-label" v-else>* Date</label>
                <flat-pickr
                  v-if="this.$vlastMode && $allowBookingDateRange"
                  v-model="$v.date.$model"
                  :config="flatPickerRangeDateConfig"
                  class="form-control pickdate"
                  placeholder="Please select a date"
                  name="date"/>
                <flat-pickr
                  v-else
                  v-model="$v.date.$model"
                  :config="flatPickerSingleDateConfig"
                  class="form-control pickdate"
                  placeholder="Please select a date"
                  name="date"
                  />

                <vuelidate-help :field="$v.date" :label="'Date'" :custom-messages="{ 'insideDateBounds': selectCampaignOptionErrorMessage }" />

                <info-alert v-if="showCriticalChangeWarnings" :type="'warning'" :message="`Changing the date(s) will notify ${$starLabelPlural} and require them to re-apply`" />
              </div>
            </div>
            <div class="col-md-6 margin-b-2" v-if="!$isNflClient && !booking.is_offer">
              <div class="form-group">
                <label class="control-label">&nbsp;</label>
                <div class="flexibleItem">
                  {{ $t('Request') }} {{ $t('date is flexible')}}

                  <toggle-button
                    :sync="true"
                    v-model="$v.date_flexible_or_unconfirmed.$model"
                    class="pull-right date_unconfirmed"
                    :color="{ checked: brandPrimary, unchecked: '#b7b7b7' }"/>

                  <input type="hidden" name="date_flexible_or_unconfirmed" :value="$v.date_flexible_or_unconfirmed.$model"/>
                </div>
              </div>
            </div>
          </div>
          <div class="row" v-if="showInPersonBooking && $v.date_flexible_or_unconfirmed.$model && !booking.is_offer">
            <div class="col-md-6" :class="hasErrorClass($v.date2, 'form-group calendar-group')">
              <label class="control-label">Date Option 2</label>
              <div class="form-group input-group calendar-group">
                <flat-pickr
                  v-model="$v.date2.$model"
                  :config="flatPickerSingleDateConfig"
                  class="form-control pickdate"
                  placeholder="Please select a date"
                  name="date2"/>
                <div class="input-group-btn">
                  <button class="btn btn-primary" type="button" title="Clear" data-clear>
                    <i class="fa fa-times">
                      <span aria-hidden="true" class="sr-only">Clear</span>
                    </i>
                  </button>
                </div>
              </div>
              <vuelidate-help :field="$v.date2" :label="'Date option 2'" :custom-messages="{ 'insideDateBounds': selectCampaignOptionErrorMessage }" />
            </div>
          </div>
          <div class="row" v-if="showInPersonBooking && $v.date_flexible_or_unconfirmed.$model && !booking.is_offer">
            <div class="col-md-6" :class="hasErrorClass($v.date3, 'form-group calendar-group')">
              <label class="control-label">Date Option 3</label>
              <div class="form-group input-group calendar-group">
                <flat-pickr
                  v-model="$v.date3.$model"
                  :config="flatPickerSingleDateConfig"
                  class="form-control pickdate"
                  placeholder="Please select a date"
                  name="date3"/>
                <div class="input-group-btn">
                  <button class="btn btn-primary" type="button" title="Clear" data-clear>
                    <i class="fa fa-times">
                      <span aria-hidden="true" class="sr-only">Clear</span>
                    </i>
                  </button>
                </div>
              </div>
              <vuelidate-help :field="$v.date3" :label="'Date option 3'" :custom-messages="{ 'insideDateBounds': selectCampaignOptionErrorMessage }" />
            </div>
          </div>
          <div class="row equal-cols" v-if="(showInPersonBooking || ($vlastMode && showOnlineBooking)) && !booking.is_offer">

            <div class="col-md-6" v-if="showInPersonBooking">
              <div :class="hasErrorClass($v.arrival_time, 'form-group calendar-group')">
                <label class="control-label" v-if="$vlastMode">* Arrival Time</label>
                <label class="control-label" v-else>Arrival Time</label>
                <flat-pickr
                  v-model="$v.arrival_time.$model"
                  :config="flatPickerTimeConfig"
                  class="form-control pickdate"
                  placeholder="2:15pm"
                  name="arrival_time"
                  step="60"/>
                  <vuelidate-help :field="$v.arrival_time" :label="'Arrival time'" />
              </div>
            </div>
            <div class="col-md-6">
              <div :class="hasErrorClass($v.athlete_start_time, 'form-group calendar-group')">
                <label class="control-label">{{$starLabel | sentenceCase}} Start Time</label>
                <flat-pickr
                  v-model="$v.athlete_start_time.$model"
                  :config="flatPickerTimeConfig"
                  class="form-control pickdate"
                  placeholder="2:30pm"
                  name="athlete_start_time"
                  step="60"/>
                <vuelidate-help :field="$v.athlete_start_time" :label="'Start time'" :custom-messages="{ 'afterArrivalTime': 'Start time cannot be before arrival time' }" />
              </div>
            </div>
            <div class="col-md-6">
              <div :class="hasErrorClass($v.athlete_leave_time, 'form-group calendar-group')">
                <label class="control-label">{{$starLabel | sentenceCase}} Finish Time</label>
                <flat-pickr
                  v-model="$v.athlete_leave_time.$model"
                  :config="flatPickerTimeConfig"
                  class="form-control pickdate"
                  placeholder="3:30pm"
                  name="athlete_leave_time"
                  step="60"/>
                <vuelidate-help v-if="this.$vlastMode" :field="$v.athlete_leave_time" :label="'Leave time'" :custom-messages="{ 'afterArrivalTime': 'Leave time must be after arrival time', 'afterStartTime': 'Leave time must be after or the same with start time' }" />
                <vuelidate-help v-else :field="$v.athlete_leave_time" :label="'Leave time'" :custom-messages="{ 'afterArrivalTime': 'Leave time must be after arrival time', 'afterStartTime': 'Leave time must be after start time' }" />
              </div>
            </div>
            <div v-if='!$hideTravelTime && showInPersonBooking' class="col-md-6">
              <div class="form-group calendar-group">
                <label class="control-label">Travel Time</label>
                <selectize
                  name="duration"
                  class="selectize selectize-single"
                  placeholder="Please select"
                  v-model="$v.travel_time.$model"
                  :options="travelDurationOptions"/>
              </div>
            </div>
            <div class="col-md-12 margin-b-2">
              <strong>Important:</strong> Both arrival and start times should be entered in the local time for event
            </div>
            <div v-if='showDurationField' class="col-md-12">
              <div class="form-group">
                <label class="control-label">{{ durationFieldLabel }}</label>

                <selectize
                  name="duration"
                  class="selectize selectize-single"
                  placeholder="Please select"
                  v-model="$v.duration.$model"
                  :options="opportunityDurationOptions"/>
              </div>
            </div>
          </div>

          <div class="form-group" v-if="showInPersonBooking && !$isNflClient && !booking.is_offer">
            <div class="flexibleItem">
              {{ $t('Are these times flexible?')}}

              <toggle-button
                :sync="true"
                v-model="$v.time_flexible_or_unconfirmed.$model"
                class="pull-right date_unconfirmed"
                :color="{ checked: brandPrimary, unchecked: '#b7b7b7' }"/>

              <input type="hidden" name="time_flexible_or_unconfirmed" :value="$v.time_flexible_or_unconfirmed.$model"/>
            </div>
          </div>

          <div class="form-group" v-if="showInPersonBooking && !$isNflClient">
            <div class="flexibleItem">
              Location unconfirmed?

              <toggle-button
                :sync="true"
                v-model="$v.location_unconfirmed.$model"
                class="pull-right date_unconfirmed"
                :color="{ checked: brandPrimary, unchecked: '#b7b7b7' }"/>

              <input type="hidden" name="date_flexible_or_unconfirmed" :value="$v.location_unconfirmed.$model"/>
            </div>
          </div>
          <div :class="hasErrorClass($v.location, 'form-group')" v-if="showInPersonBooking">
            <label class="control-label">Location</label>
            <gmap-autocomplete
              name="location"
              class="form-control "
              :placeholder="$tc('request_stars.location_example')"
              :value="booking.address"
              :options="googleMapOptions"
              :bounds="googleMapOptions.bounds"
              @place_changed="handleAddressChangeCallback"
              @input.native="handleResetAddressCallback"
              @keydown.native.enter.prevent/>

            <input type="hidden" name="street_address" :value="$v.street_address.$model"/>
            <input type="hidden" name="suburb" :value="$v.suburb.$model"/>
            <input type="hidden" name="area" :value="$v.area.$model"/>
            <input type="hidden" name="state" :value="$v.state.$model"/>
            <input type="hidden" name="country" :value="$v.country.$model"/>
            <input type="hidden" name="postcode" :value="$v.postcode.$model"/>
            <input type="hidden" name="latitude" :value="$v.latitude.$model"/>
            <input type="hidden" name="longitude" :value="$v.longitude.$model"/>
            <vuelidate-help :field="$v.location" :label="'Location'" />
          </div>

          <div class="form-group" v-if="showInPersonBooking">
            <label class="control-label">Additional Location Detail </label>

            <input
              name="additional_location_detail"
              type="text"
              class="form-control"
              v-model="$v.additional_location_detail.$model"
              :placeholder="$tc('Additional Location Placeholder')"
            />
          </div>
        </template>

        <div class="row" v-if="$vlastMode && monetaryCurrency && $userIsAdmin && $requestFormConfig.show_commission && !booking.is_offer">
          <div class="col-sm-6 col-md-6">
            <div :class="hasErrorClass($v.commission_rate, 'filter form-group')">
              <label class="control-label">{{ clientName }} commission per {{ $starLabel.toLowerCase() }}</label>
              <div class="row">
                <div class="col-sm-5 col-md-5">
                  <div class="input-group">
                    <input
                      name="commission_rate"
                      type="number"
                      min="0"
                      autocomplete="off"
                      class="form-control"
                      v-model="$v.commission_rate.$model"
                      :disabled="!!$v.commission_dollar.$model"
                    />

                    <span class="input-group-addon"><i class="fa fa-percent"></i></span>
                  </div>

                  <vuelidate-help :field="$v.commission_rate" :label="'commission rate'"/>
                </div>
                <div class="col-sm-1 col-md-1" style="padding: 0; padding-top: 10px; text-align: center;">OR</div>
                <div class="col-sm-5 col-md-5">
                  <div :class="hasErrorClass($v.commission_dollar, 'filter form-group')">
                    <div class="input-group">
                      <span class="input-group-addon"><i class="fa fa-usd"></i></span>

                      <input
                        name="commission_dollar"
                        type="text"
                        class="form-control"
                        v-model="$v.commission_dollar.$model"
                        :disabled="!!$v.commission_rate.$model"
                      />
                    </div>

                    <vuelidate-help :field="$v.commission_dollar" :label="'Commission'"/>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col-sm-4 col-md-3" v-if="( $costReferences && ($clientSetsBudget || $userIsAdmin)) && !booking.is_offer">
            <div :class="hasErrorClass($v.budget_per_star, 'filter form-group')">
              <label class="control-label" v-if="$vlastMode && $isOtis" v-html="booking.currency === 'points' ? $t('Request') + ' Points': $t('Request') + ' ' + $options.filters.sentenceCase($t('budget'))"></label>
              <label class="control-label" v-else v-html="booking.currency === 'points' ? 'Points per ' + $starLabel.toLowerCase() : $options.filters.sentenceCase($t('budget')) + ' per ' + $starLabel.toLowerCase()"></label>
              <div class="input-group form-group">
                <span class="input-group-addon">{{ moneySymbol }}</span>
                <input
                  :disabled="!!(!booking.id && $opportunityPointsModuleEnabled)"
                  id="budget"
                  name="budget_per_star"
                  v-model="$v.budget_per_star.$model"
                  type="text"
                  class="form-control"
                  placeholder="0"
                />

              </div>
              <vuelidate-help :field="$v.budget_per_star" :label="'Budget'" />

              <info-alert v-if="showBudgetAlert" :type="'warning'" :message="`Changing the budget will notify ${$starLabelPlural} and require them to re-apply`" />
            </div>
          </div>
          <div class="col-sm-4 col-md-3" v-if="($vlastMode && !$isQas && $budgetCode && !booking.is_offer)">
            <div :class="hasErrorClass($v.budget_code, 'filter form-group')">
              <label class="control-label">Budget Code</label>
              <div class="input-group w-full">
                <input
                  name="budget_code"
                  v-model="$v.budget_code.$model"
                  type="text"
                  class="form-control"
                />
              </div>

              <vuelidate-help :field="$v.budget_code" :label="'Budget code'" />
            </div>
          </div>
          <div class="col-sm-4 col-md-3" v-if="($vlastMode && $isQas && $userIsAdmin && ($budgetCode || !$budgetCode) && !booking.is_offer)">
            <div :class="hasErrorClass($v.cost_centre, 'filter form-group')">
              <label class="control-label">Cost Centre</label>
              <div class="input-group w-full">
                <input
                  name="cost_centre"
                  v-model="$v.cost_centre.$model"
                  type="text"
                  class="form-control"
                />
              </div>

              <vuelidate-help :field="$v.cost_centre" :label="'Cost centre'" />
            </div>
          </div>
          <div class="col-sm-4 col-md-3" v-if="($vlastMode && $isQas && $userIsAdmin && ($budgetCode || !$budgetCode) && !booking.is_offer)">
            <div :class="hasErrorClass($v.gl_code, 'filter form-group')">
              <label class="control-label">GL Code</label>
              <div class="input-group w-full">
                <input
                  name="cost_centre"
                  v-model="$v.gl_code.$model"
                  type="text"
                  class="form-control"
                />
              </div>

              <vuelidate-help :field="$v.gl_code" :label="'GL Code'" />
            </div>
          </div>
          <div class="col-sm-4 col-md-3">
            <div :class="hasErrorClass($v.required_stars, 'filter form-group')">
              <label class="control-label">* I am looking for</label>
              <div class="input-group">
                <input
                  v-if="$vlastMode && $offersModuleEnabled && booking.is_offer"
                  name="required_stars"
                  v-model="$v.required_stars.$model"
                  type="number"
                  min="0"
                  class="form-control"
                />
                <input
                  v-else
                  name="required_stars"
                  v-model="$v.required_stars.$model"
                  type="number"
                  min="1"
                  class="form-control"
                />

                <span class="input-group-addon">{{ $starLabel | sentenceCase }}(s)</span>
              </div>

              <vuelidate-help :field="$v.required_stars" :label="`Number of ${$starLabelPlural}`" />
            </div>
          </div>
        </div>

        <div class="col-sm-10 col-md-8" style="text-align: left; padding-left: 10px;" v-if="($costReferences && ($clientSetsBudget || $userIsAdmin) && !booking.is_offer)">
          <template v-if="$vlastMode">
            <template v-if="this.$isACA">
              <p>
                Please enter the total fee for this appearance based on the type and duration:<br>
                Metro: $150/hour (min. $300 for up to 2 hours)<br>
                Regional: $250/hour (min. $500 for up to 2 hours)<br>
                Round up to the nearest half hour when calculating total hours.
              </p>
            </template>
            <template v-else>
              <p v-if="booking.currency !== 'points'">Total {{ $t('budget') }} {{ bookingTotalBudget | currency(booking.currency) }} <span v-if="($v.commission_dollar.$model || $v.commission_rate.$model)" > ({{ bookingTotalBudgetWithoutCommission | currency(booking.currency) }})</span>{{ $showTax ? ' (plus tax)' : ''}}</p>
            </template>
          </template>
          <template v-else>
            <p>Total {{ bookingTotalBudget | currency(booking.currency) }}</p>
          </template>
        </div>

        <div class="row" v-if="($costReferences && ($clientSetsBudget || $userIsAdmin) && !booking.is_offer)">
          <div class="col-xs-12">
            <div class="form-group">
              <div v-if="$requestFormConfig.allow_unconfirmed_budgets"  class="flexibleItem">
                {{ $t('budget') | sentenceCase }} unconfirmed?

                <toggle-button
                  :sync="true"
                  v-model="$v.budget_not_confirmed.$model"
                  class="pull-right date_unconfirmed"
                  :color="{ checked: brandPrimary, unchecked: '#b7b7b7' }"/>

                <input type="hidden" name="budget_not_confirmed" :value="$v.budget_not_confirmed.$model"/>
              </div>
            </div>
          </div>
        </div>

        <div class="row" v-if="$userIsAdmin && $vlastMode && !booking.is_offer">
          <div class="col-xs-12">
            <div class="form-group">
              <div class="flexibleItem">
                Do you want the {{ $starLabel }} to view all booked {{ $starLabel }} profiles for this request?

                <toggle-button
                  :sync="true"
                  v-model="$v.show_all_talents.$model"
                  class="pull-right"
                  :color="{ checked: brandPrimary, unchecked: '#b7b7b7' }"/>

                <input type="hidden" name="show_all_talents" :value="$v.show_all_talents.$model"/>
              </div>
            </div>
          </div>
        </div>

      </div>
    </div>

    <div class="event-map" v-if="bookingAppearanceInPerson && showMap">
      <gmap-map
        :center="{
                lat: $v.latitude.$model || defaultLatLng.lat,
                lng: $v.longitude.$model || defaultLatLng.lng
              }"
        :zoom="$v.latitude.$model && $v.longitude.$model ? 10 : defaultLatLng.zoom"
        ref="eventMap">
        <gmap-marker
          :position="bookingLatitudeAndLongitude"/>
      </gmap-map>
    </div>

    <div v-if="fieldSetSelected('social_post')" class="panel panel-send-request">
      <div class="panel-body">
        <h3>Social Post Details</h3>
        <hr/>
        <div :class="hasErrorClass($v.post_caption, 'form-group')">
          <label class="control-label">
            Social Content
          </label>
          <div class="redactor-editor-wrapper">
            <redactor
              v-model="$v.post_caption.$model"
              name="post_caption"
              :options="redactorOptions"/>
          </div>
        </div>
        <p class="requirements-info" v-if="displayMarketingDisclaimer">
          Important: When talent are required to complete a promotional or branded post on their social media accounts, it is likely this will need to be disclosed as advertising (e.g. #ad or #spon). To find out if this is relevant to you, read more <a target="_blank" :href="socialMediaDisclosureLink">here</a> or email <a :href="'mailto:' + $user.region.admin_email">{{ $user.region.admin_email }}</a> if you have any questions.
        </p>
        <booking-field-input
          :classes="hasErrorClass($v.social_post_location, 'form-group')"
          :validations="$v.social_post_location"
          :booking="booking"
          :property-mutator="propertyMutator"
          field="social_post_location"
          field-type="select"
          :options="socialLocationOptions"
          label="* Social Post Location"/>
        <div :class="hasErrorClass($v.number_of_social_media_posts, 'filter form-group')">
          <label class="control-label">* Number of posts required</label>
          <div class="input-group">
            <input
              name="number_of_posts_required"
              v-model="$v.number_of_social_media_posts.$model"
              type="number"
              min="1"
              class="form-control"
            />

            <span class="input-group-addon">Post(s)</span>
          </div>

          <vuelidate-help :field="$v.number_of_social_media_posts" :label="'Number of posts'" />
        </div>
        <ul v-if="showPaidAdvertising" class="more-details">
          <li >
            Will this be used In Paid Advertising
            <toggle-button
              v-model="$v.paid_advertising.$model"
              :sync="true"
              class="pull-right"
              :color="{ checked: brandPrimary, unchecked: '#b7b7b7' }"/>

            <input type="hidden" name="paid_advertising" :value="$v.paid_advertising.$model"/>
          </li>
        </ul>
        <booking-field-input
          v-if="$v.paid_advertising.$model"
          :classes="hasErrorClass($v.rights_length, 'form-group')"
          :validations="$v.rights_length"
          :booking="booking"
          :property-mutator="propertyMutator"
          field="rights_length"
          field-type="select"
          :options="socialLengthOptions"
          label="Rights Length"/>
      </div>
    </div>

    <div v-if="fieldSetSelected('ambassador')" class="panel panel-send-request">
      <div class="panel-body">
        <h3>Brand Ambassador Details</h3>
        <hr/>
        <booking-field-input
          :classes="hasErrorClass($v.ambassador_length, 'form-group')"
          :validations="$v.ambassador_length"
          :booking="booking"
          :property-mutator="propertyMutator"
          field="ambassador_length"
          field-type="select"
          :options="ambassadorLengthOptions"
          label="* Ambassador Length"/>
        <booking-field-input
          :classes="hasErrorClass($v.target_market, 'form-group')"
          :validations="$v.target_market"
          :booking="booking"
          :property-mutator="propertyMutator"
          field="target_market"
          label="* Target Market"/>
        <div :class="hasErrorClass($v.ambassadorship_details, 'form-group')">
          <label class="control-label">
            Ambassadorship Details
          </label>
          <div class="redactor-editor-wrapper">
            <redactor
              v-model="$v.ambassadorship_details.$model"
              name="ambassadorship_details"
              placeholder="Add any further details you may have about this ambassadorship"
              :options="redactorOptions"/>
          </div>
        </div>
        <div>
          <div :class="hasErrorClass($v.commencement_date, 'form-group calendar-group')">
            <label class="control-label">* Commencement Date</label>
            <flat-pickr
              v-model="$v.commencement_date.$model"
              :config="flatPickerSingleDateConfig"
              class="form-control pickdate"
              placeholder="Please select a date"
              name="commencement_date"/>

            <vuelidate-help :field="$v.commencement_date" :label="'Commencement Date'" :custom-messages="{ 'insideDateBounds': selectCampaignOptionErrorMessage }" />
          </div>
        </div>

        <div v-if="fieldSetSelected('marketing_campaign')">
          <booking-field-input
            :classes="hasErrorClass($v.marketing_channels, 'form-group')"
            :validations="$v.marketing_channels"
            :booking="booking"
            :property-mutator="propertyMutator"
            field="marketing_channels"
            field-type="multi-select"
            :multi-select-types="['marketing_channel']"
            label="* Marketing Channels"/>
          <ul class="more-details">
            <li >
              Do you require an In Person Shoot

              <toggle-button
                v-model="$v.shoot_required.$model"
                :sync="true"
                class="pull-right"
                :color="{ checked: brandPrimary, unchecked: '#b7b7b7' }"/>

              <input type="hidden" name="expenses_covered" :value="$v.shoot_required.$model"/>
            </li>
          </ul>
        </div>
      </div>
    </div>

    <template v-if="$vlastMode && this.booking.custom_fields && this.booking.custom_fields.length > 0">
      <div class="panel panel-send-request">
        <div class="panel-body">
          <h3>Additional {{ $t('request') }} details</h3>
          <hr />
          <div class="form-group">
          <div v-for="(field, index) in booking.custom_fields" :key="field.name">
            <div class="form-group" >
              <label class="control-label">{{field.name}}</label>
              <div v-if="field.dataType === 'text' || field.dataType === undefined">
                <input type="text" class="form-control" v-model="booking.custom_fields[index].value" maxlength="1024"/>
              </div>
              <div v-if="field.dataType === 'file'">
                <file-input v-model="booking.custom_fields[index].value" :prefix="'booking-custom-fields'"/>
              </div>
              <div v-else-if="field.dataType === 'date'">
                <div class="calendar-group">
                  <flat-pickr
                    v-model="booking.custom_fields[index].value"
                    :config="flatPickerSingleDateConfig"
                    class="form-control pickdate"
                    name="date"/>
                </div>
              </div>
              <div v-else-if="field.dataType === 'dropdown'">
                <selectize
                  class="selectize selectize-single w-full"
                  name="timezone"
                  v-model="booking.custom_fields[index].value"
                  :options="getListOptions(field.listOptions)">
                </selectize>
              </div>
            </div>
          </div>
          </div>
        </div>
      </div>
    </template>

    <template v-for="panel in $requestFormConfig.shortlist_before_deliverables ? ['shortlist', 'files', 'deliverables', 'video_message'] : [ 'deliverables', 'video_message', 'files', 'shortlist' ]" >

      <div v-if="panel === 'deliverables'" :key="panel" class="panel panel-send-request">
        <div class="panel-body">
          <h3>{{ $t('your deliverables') | sentenceCase }}</h3>
          <hr />
          <div :class="hasErrorClass($v.description, 'form-group')">
            <label class="control-label">
              * {{ $tc('request_stars.deliverables_title') }}
            </label>
            <div class="redactor-editor-wrapper">
              <redactor
                v-model="$v.description.$model"
                name="description"
                :placeholder="$tc('request_stars.deliverables_example')"
                :options="redactorOptions"/>
            </div>
            <vuelidate-help :field="$v.description" :label="'Description'" />
            <p v-if="$t('request_stars.deliverables_description')" style="white-space: pre;">{{ $t('request_stars.deliverables_description') }}</p>
          </div>

          <div v-if="showInPersonBooking && $showDressCode">
            <div :class="hasErrorClass($v.dress_code, 'form-group')">
              <label class="control-label">Dress Code</label>
              <div class="input-group w-full">
                <input
                  name="dress_code"
                  v-model="$v.dress_code.$model"
                  type="text"
                  class="form-control"
                />
              </div>
              <vuelidate-help :field="$v.dress_code" :label="'Dress code'" />
            </div>
          </div>

          <div class="form-group" v-if="$v.requirements.$model">
            <label class="control-label">{{ $starLabel | sentenceCase }} requirements &ndash;
              <span class="small">tell us in as much detail as you can what you want the {{ $starLabel }} to do</span>
            </label>
            <textarea
              id="requirements"
              name="requirements"
              v-model="$v.requirements.$model"
              class="form-control"
              rows="6"
              placeholder="For example: I want the sports star to mingle with event attendees for 30 minutes, signing autographs and posing for photos with fans etc. Then take part in a 30 minute Q and A interview about their career, talking about overcoming adversity and lessons learned. I would then like the talent to post a photo from the event to their Instagram account."/>
            <p class="requirements-info" v-if="showInPersonBooking">
              Important: When {{ $starLabelPlural }} are required to complete a promotional or branded post on their social media accounts, it is likely this will need to be disclosed as advertising (e.g. #ad or #spon). To find out if this is relevant to you, read more
              <a target="_blank" :href="socialMediaDisclosureLink">here</a>
              <span v-if="!$vlastMode" >
              &nbsp;or email <a :href="'mailto:' + $user.region.admin_email">{{ $user.region.admin_email }}</a> if you have any questions.
            </span>
            </p>
          </div>

<!--          TODO: Booking custom fields CU-3judex-->
          <div v-if="clientName === 'auscricket'" class="row">
            <div class="col-md-4" :class="hasErrorClass($v.aca_number_participants, 'filter form-group')">
              <label class="control-label">* Approximate number of participants</label>
              <div class="input-group">
                <input
                  name="aca_number_participants"
                  v-model="$v.aca_number_participants.$model"
                  type="number"
                  min="1"
                  class="form-control"
                />

                <span class="input-group-addon">Participant(s)</span>
              </div>
            </div>

            <div class="col-md-8" :class="hasErrorClass($v.aca_participant_ability, 'filter form-group')">
              <label class="control-label">* Participant age and ability</label>
              <textarea
                name="aca_participant_ability"
                v-model="$v.aca_participant_ability.$model"
                class="form-control"
              />
            </div>
          </div>
<!--          TODO: Booking custom fields CU-3judex-->

          <ul class="more-details">
            <li v-if="!$vlastMode">
              I will cover travel and accommodation expenses (if applicable)

              <toggle-button
                v-model="$v.expenses_covered.$model"
                :sync="true"
                class="pull-right"
                :color="{ checked: brandPrimary, unchecked: '#b7b7b7' }"/>

              <input type="hidden" name="expenses_covered" :value="$v.expenses_covered.$model"/>
            </li>
            <li v-if="!$vlastMode && !$hidePublicPromotingStatus">
              I am promoting this {{ $t('request') }} publicly

              <toggle-button
                v-model="$v.promoted_publicly.$model"
                :sync="true"
                class="pull-right"
                :color="{ checked: brandPrimary, unchecked: '#b7b7b7' }"/>

              <input type="hidden" name="promoted_publicly" :value="$v.promoted_publicly.$model"/>
            </li>
          </ul>
        </div>
      </div>

      <div v-if="panel === 'files' && $allowRequestFileUploads" :key="panel" class="panel panel-send-request">
        <div class="panel-body">
          <request-upload-files :booking="booking"/>
        </div>
      </div>

      <div v-if="panel === 'shortlist' && (!bookingTypeIsBooking || duplicated)" :key="panel"  class="panel panel-send-request" >
        <div class="panel-body">
          <h3>{{ $t('Your Shortlist') }}</h3>

          <slot name="shortlist"></slot>

          <ul class="more-details" v-if="($userIsAdmin || $vlastMode)">
            <li v-if="$isNflClient && $userIsClient">
              Player relations to add players
              <toggle-button
                class="pull-right"
                :color="{ checked: brandPrimary, unchecked: '#b7b7b7' }"/>
            </li>
            <li v-if="$billboardModuleEnabled">
              {{$tc('request_stars.make_public')}}

              <toggle-button
                :sync="true"
                v-model="$v.others_can_apply.$model"
                class="pull-right"
                :disabled="forceBillboard"
                :color="{ checked: brandPrimary, unchecked: '#b7b7b7' }"/>

              <input type="hidden" name="others_can_apply" :value="$v.others_can_apply.$model"/>
            </li>
            <li v-if="$userIsGlobalAdmin && regionOptions.length > 1" class="flex items-center">
              <span class="spacer-r-1">Region</span>
              <selectize
                class="selectize selectize-single w-full"
                name="timezone"
                v-model="$v.region_id.$model"
                :options="regionOptions">
              </selectize>
            </li>
          </ul>
        </div>
      </div>

      <div v-if="panel === 'video_message' && fieldSetSelected('video_message')" :key="panel" class="panel panel-send-request">
        <div class="panel-body">
          <h3>Video Message Details</h3>
          <hr/>
          <div :class="hasErrorClass($v.video_caption, 'form-group')">
            <label class="control-label">
              * Video Content
            </label>
            <div class="redactor-editor-wrapper">
              <redactor
                v-model="$v.video_caption.$model"
                name="video_caption"
                placeholder="Enter a description of what you'd like the talent to talk about. Serious or funny in nature? Do you have any funny stories or habits you want me to mention? What’s the special occasion or purpose?"
                :options="redactorOptions"/>
            </div>
          </div>

          <ul class="more-details">
            <li>
              Is this being used for commercial purposes
              <toggle-button
                v-model="$v.commercial_purposes.$model"
                :sync="true"
                class="pull-right"
                :color="{ checked: brandPrimary, unchecked: '#b7b7b7' }"/>

              <input type="hidden" name="commercial_purposes" :value="$v.commercial_purposes.$model"/>
            </li>
          </ul>
          <div v-if="$v.commercial_purposes.$model">
            <booking-field-input
              :classes="hasErrorClass($v.video_message_places, 'form-group')"
              :booking="booking"
              :property-mutator="propertyMutator"
              :validations="$v.video_message_places"
              field="video_message_places"
              other-field="other_video_usage"
              :other-classes="hasErrorClass($v.other_video_usage, 'form-group')"
              :otherValidations="$v.other_video_usage"
              field-type="multi-select-options"
              :options="videoMessageUsageLocationOptions"
              label="* Usage Locations"/>

            <booking-field-input
              :classes="hasErrorClass($v.video_rights_length, 'form-group')"
              :booking="booking"
              :validations="$v.video_rights_length"
              :property-mutator="propertyMutator"
              field="video_rights_length"
              field-type="select"
              :options="rightsLengthOptions"
              label="* Rights Length"/>
          </div>
          <div v-else>
            <booking-field-input
              :classes="hasErrorClass($v.video_message_first_name, 'form-group')"
              :booking="booking"
              :property-mutator="propertyMutator"
              :validations="$v.video_message_first_name"
              field="video_message_first_name"
              label="* First Name"/>
            <booking-field-input
              :classes="hasErrorClass($v.video_message_last_name, 'form-group')"
              :booking="booking"
              :property-mutator="propertyMutator"
              :validations="$v.video_message_last_name"
              field="video_message_last_name"
              label="* Last Name"/>
          </div>
        </div>
      </div>

    </template>

    <div class="panel panel-send-request" v-if="!$vlastMode">
      <div class="panel-body">
        <h3>Coupon Code</h3>

        <p>
          If you have received a coupon code please enter it below.
        </p>

        <div class="row">
          <div class="col-xs-12">
            <div class="form-group">
              <input
                name="coupon"
                type="text"
                class="form-control"
                placeholder="CODE123"
                v-model.lazy="$v.coupon.$model">
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {each, sumBy, maxBy, cloneDeep} from 'lodash'
import $ from 'jquery'
import moment from 'moment'
import {mapActions, mapState} from 'vuex'
import stateMapper from 'mixins/bookings/bookingform/state-mapper'
import { helpers } from 'mixins/bookings'
import Selectize from '../ext/codium/CodiumSelectize'
import FlatPickr from 'vue-flatpickr-component'
import VuelidateHelp from './VuelidateHelp'
import {required, requiredIf, numeric, between, url} from 'vuelidate/lib/validators'
import BookingFieldInput from './BookingFieldInput'
import BookingFieldBoolean from '../booking/BookingFieldBoolean'
import DepartmentSelection from './DepartmentSelection'
import getSymbolFromCurrency from 'currency-symbol-map'
import Redactor from 'codium-redactor'
import FileInput from './FileInput'
import RequestUploadFiles from '../booking/request/RequestUploadFiles'
import InfoAlert from '../globals/InfoAlert'
import { http } from 'utils'
import insideDateBounds from '../../../validators/insideDateBounds'

export default {
  mixins: [stateMapper, helpers],

  components: {
    Redactor,
    DepartmentSelection,
    Selectize,
    FlatPickr,
    VuelidateHelp,
    BookingFieldInput,
    BookingFieldBoolean,
    FileInput,
    RequestUploadFiles,
    InfoAlert
  },

  props: {
    propertyMutator: {
      required: true,
      type: Function
    },
    booking: {
      required: true,
      type: Object
    },
    inPersonOpportunityOptions: {
      required: true,
      type: Array
    },
    onlineOpportunityOptions: {
      required: true,
      type: Array
    },
    categoryOptions: {
      required: true,
      type: Array
    },
    forceBillboard: {
      required: false,
      type: Boolean,
      default: false
    },
    validationTriggered: {
      required: true,
      type: Boolean
    },
    duplicated: {
      required: false,
      type: Boolean,
      default: false
    },
    additionalDepartments: {
      required: false,
      default: []
    }
  },

  validations () {
    return {
      nfl_event_type: {
        required: requiredIf(function () {
          return this.$vlastMode && this.$isNflClient && !this.booking.is_offer
        })
      },
      name: {
        required
      },
      campaign_id: {},
      category: {
        required: requiredIf(function () {
          return this.$categoryModuleEnabled && !this.booking.is_offer
        })
      },
      department_id: {
        required: requiredIf(function () {
          return this.$vlastMode && (this.$userIsAdmin || (this.$clientDepartment && this.$userIsClient)) && this.$showDepartmentField && !this.booking.is_offer
        })
      },
      segment: {
        required: requiredIf(function () {
          return !this.$vlastMode
        })
      },
      organisation_name: {},
      location_unconfirmed: {
        default: false
      },
      cba: {},
      location: {},
      street_address: {},
      suburb: {},
      state: {},
      country: {},
      postcode: {},
      area: {},
      latitude: {},
      longitude: {},
      additional_location_detail: {},
      date: {
        required: requiredIf(function () {
          if (this.$vlastMode) {
            return true
          } else {
            if (this.booking.appearance_type !== 'online' && (this.fieldSetSelected('attend_event') || this.shoot_required)) {
              return true
            }
            return this.booking.appearance_type !== 'online'
          }
        }),
        insideDateBounds: insideDateBounds(this.selectedCampaignOption ? this.selectedCampaignOption.start_date : null, this.selectedCampaignOption ? this.selectedCampaignOption.end_date : null)
      },
      date_flexible_or_unconfirmed: {},
      time_flexible_or_unconfirmed: {},
      date2: {
        insideDateBounds: insideDateBounds(this.selectedCampaignOption ? this.selectedCampaignOption.start_date : null, this.selectedCampaignOption ? this.selectedCampaignOption.end_date : null)
      },
      date3: {
        insideDateBounds: insideDateBounds(this.selectedCampaignOption ? this.selectedCampaignOption.start_date : null, this.selectedCampaignOption ? this.selectedCampaignOption.end_date : null)
      },
      arrival_time: {
        required: requiredIf(() => {
          return this.$vlastMode && this.showInPersonBooking && !this.booking.is_offer
        })
      },
      travel_time: {},
      budget_code: {},
      cost_centre: {},
      gl_code: {},
      dress_code: {},
      video_url: {
        url
      },
      athlete_leave_time: {
        afterArrivalTime: (value) => {
          if (value && this.arrival_time && this.showInPersonBooking && !this.booking.is_offer) {
            return value > this.arrival_time
          }
          return true
        },
        afterStartTime: (value) => {
          if (value && this.athlete_start_time && this.showInPersonBooking && this.$vlastMode && !this.booking.is_offer) {
            return value >= this.athlete_start_time
          }
          if (value && this.athlete_start_time && this.showInPersonBooking) {
            return value > this.athlete_start_time
          }
          return true
        }
      },
      athlete_start_time: {
        afterArrivalTime: (value) => {
          if (value && this.arrival_time && this.showInPersonBooking && !this.booking.is_offer) {
            return value >= this.arrival_time
          }
          return true
        }
      },
      duration: {
        required: requiredIf(function () {
          return this.showDurationField && !this.booking.is_offer
        })
      },
      complete_by_date: {
        required: requiredIf(function () {
          return !this.$vlastMode && this.booking.appearance_type !== 'in_person'
        }),
        insideDateBounds: insideDateBounds(this.selectedCampaignOption ? this.selectedCampaignOption.start_date : null, this.selectedCampaignOption ? this.selectedCampaignOption.end_date : null)
      },
      budget_per_star: {
        required: requiredIf(function () {
          return !this.$vlastMode
        })
      },
      commission_rate: {
        numeric,
        between: between(1, 100)
      },
      commission_dollar: {
        lessThanBudget (value) {
          return this.$vlastMode &&
          this.monetaryCurrency &&
          this.$costReferences &&
          this.$userIsAdmin &&
          this.booking.budget_per_star &&
          value ? !isNaN(value) && parseFloat(value) < parseFloat(this.booking.budget_per_star) : true
        }
      },
      budget_not_confirmed: {
        default: false
      },
      required_stars: {
        required,
        ...!this.$vlastMode || (this.$vlastMode && !this.$offersModuleEnabled) ? { between: between(1, 50) } : {},
        numeric
      },
      description: {
        required
      },
      requirements: {},
      expenses_covered: {},
      promoted_publicly: {},
      others_can_apply: {
        required: requiredIf(function () {
          return this.$billboardModuleEnabled && !this.booking.is_offer
        })
      },
      show_all_talents: {},
      coupon: {},
      agency_stage: {
        required: requiredIf(function () {
          return this.booking.segment === 'agency' && !this.$vlastMode
        })
      },
      opportunities: {
        required
      },
      commercial_purposes: {
        default: false
      },
      video_caption: {
        required: requiredIf(function () {
          return this.fieldSetSelected('video_message') && !this.booking.is_offer
        })
      },
      video_message_first_name: {
        required: requiredIf(function () {
          return this.fieldSetSelected('video_message') && !this.booking.commercial_purposes && !this.booking.is_offer
        })
      },
      video_message_last_name: {
        required: requiredIf(function () {
          return this.fieldSetSelected('video_message') && !this.booking.commercial_purposes && !this.booking.is_offer
        })
      },
      video_message_places: {
        required: requiredIf(function () {
          return this.fieldSetSelected('video_message') && this.booking.commercial_purposes && !this.booking.is_offer
        })
      },
      video_rights_length: {
        required: requiredIf(function () {
          return this.fieldSetSelected('video_message') && this.booking.commercial_purposes && !this.booking.is_offer
        })
      },
      rights_length: {
        required: requiredIf(function () {
          return this.fieldSetSelected('social_post') && this.booking.paid_advertising && !this.booking.is_offer
        })
      },
      ambassadorship_details: {},
      commencement_date: {
        required: requiredIf(function () {
          return this.fieldSetSelected('ambassador')
        }),
        insideDateBounds: insideDateBounds(this.selectedCampaignOption ? this.selectedCampaignOption.start_date : null, this.selectedCampaignOption ? this.selectedCampaignOption.end_date : null)
      },
      ambassador_length: {
        required: requiredIf(function () {
          return this.fieldSetSelected('ambassador') && !this.booking.is_offer
        })
      },
      target_market: {
        required: requiredIf(function () {
          return this.fieldSetSelected('ambassador') && !this.booking.is_offer
        })
      },
      marketing_channels: {
        required: requiredIf(function () {
          return this.fieldSetSelected('ambassador') && this.fieldSetSelected('marketing_campaign') && !this.booking.is_offer
        })
      },
      shoot_required: {},
      post_caption: {},
      social_post_location: {
        required: requiredIf(function () {
          return this.fieldSetSelected('social_post') && !this.booking.is_offer
        })
      },
      number_of_social_media_posts: {
        required: requiredIf(function () {
          return this.fieldSetSelected('social_post') && !this.booking.is_offer
        }),
        between: between(1, 100),
        numeric
      },
      paid_advertising: {
        default: false
      },
      other: {},
      other_agency_stage: {
        required: requiredIf(function () {
          return this.booking.agency_stage === 'Other' && !this.booking.is_offer
        })
      },
      other_video_usage: {
        required: requiredIf(function () {
          return this.fieldSetSelected('video_message') && this.booking.commercial_purposes &&
            this.otherVideoSelected && !this.booking.is_offer
        })
      },
      region_id: {
        required: requiredIf(function () {
          return !this.booking.is_offer
        })
      },
      aca_event_location: {},
      aca_event_distance: {},
      aca_event_gender: {},
      aca_number_participants: {},
      aca_participant_ability: {}
    }
  },

  data () {
    return {
      appearanceTypeNoOfferOptions: [
        { id: 'in_person', text: 'In person' },
        { id: 'online', text: 'Online' },
        { id: 'both', text: 'Both' }
      ],
      appearanceTypeOfferOptions: [
        { id: 'in_person', text: 'In person' },
        { id: 'online', text: 'Online' },
        { id: 'both', text: 'Both' },
        { id: 'offer', text: 'Offer' }
      ],
      showMap: false,
      audience: [],
      prevAssignedAdmin: null,
      downloading: false,
      first: true,
      regionOptions: [],
      campaignOptions: [],
      campaignPagination: {},
      ambassadorLengthOptions: [
        { id: '< 3 Months', text: '< 3 Months' },
        { id: '3 Months', text: '3 Months' },
        { id: '6 Months', text: '6 Months' },
        { id: '12 Months', text: '12 Months' },
        { id: '> 12 Months', text: '> 12 months' }
      ],
      rightsLengthOptions: [
        { id: '1 Month', text: '1 Month' },
        { id: '6 Months', text: '6 Months' },
        { id: '1 Year', text: '1 Year' },
        { id: '2 Years', text: '2 Years' }
      ],
      socialLengthOptions: [
        { id: '< 3 Months', text: '< 3 Months' },
        { id: '3 Months', text: '3 Months' },
        { id: '6 Months', text: '6 Months' },
        { id: '12 Months', text: '12 Months' },
        { id: '> 12 Months', text: '> 12 Months' },
        { id: 'Undecided', text: 'Undecided' }
      ],
      agencyStageOptions: [
        {
          'id': 'Brief',
          'text': 'I am responding to a brief'
        },
        {
          'id': 'Proactive',
          'text': 'I am doing a proactive'
        },
        {
          'id': 'Approval',
          'text': 'Have approval and seeking talent'
        },
        {
          'id': 'Other',
          'text': 'Other'
        }
      ],
      travelDurationOptions: [
        { id: ':15', text: '15 Minutes' },
        { id: ':30', text: '30 Minutes' },
        { id: ':45', text: '45 Minutes' },
        { id: '1:00', text: '1 Hour' },
        { id: '1:30', text: '1.5 Hours' },
        { id: '2:00', text: '2 Hours' },
        { id: '2:30', text: '2.5 Hours' },
        { id: '3:00', text: '3 Hours' },
        { id: '3:30', text: '3.5 Hours' },
        { id: '4:00', text: '4 Hours' },
        { id: '4:30', text: '4.5 Hours' },
        { id: '5:00', text: '5 Hours' }
      ],
      opportunityDurationOptions: [
        { id: '15 Minutes', text: '15 Minutes' },
        { id: '30 Minutes', text: '30 Minutes' },
        { id: '1 Hour', text: '1 Hour' },
        { id: '1.5 Hours', text: '1.5 Hours' },
        { id: '2 Hours', text: '2 Hours' },
        { id: '2.5 Hours', text: '2.5 Hours' },
        { id: '3 Hours', text: '3 Hours' },
        { id: '3.5 Hours', text: '3.5 Hours' },
        { id: '4 Hours', text: '4 Hours' },
        { id: 'Full Day', text: 'Full Day' }
      ],
      dressCodeOptions: [
        { id: 'active_wear', text: 'Active Wear' },
        { id: 'neat_casual', text: 'Neat Casual' },
        { id: 'business_casual', text: 'Business Casual' },
        { id: 'suit_and_tie', text: 'Suit and Tie' }
      ],
      parkingOptions: [
        { id: 'provided', text: 'Provided' },
        { id: 'not_provided', text: 'Not Provided' }
      ],
      segmentOptions: [
        { id: 'agency', text: 'Agency' },
        { id: 'association', text: 'Association' },
        { id: 'brand', text: 'Brand' },
        { id: 'business', text: 'Business' },
        { id: 'club', text: 'Club' },
        { id: 'fan', text: 'Fan' },
        { id: 'government', label: 'Government' },
        { id: 'charity', label: 'Not-For-Profit' },
        { id: 'school', text: 'School' }
      ],
      acaGenderOptions: [
        { id: 'Male', text: 'Male' },
        { id: 'Female', text: 'Female' },
        { id: 'Both', text: 'Both' }
      ],
      acaLocationOptions: [
        { id: 'Metro Event (within 100kms from CBD)', text: 'Metro Event (within 100kms from CBD)' },
        { id: 'Regional Event (100kms from CBD)', text: 'Regional Event (100kms from CBD)' }
      ],
      nflEventTypeOptions: [
        { id: 'Pro Bowl', text: 'Pro Bowl' },
        { id: 'Super Bowl', text: 'Super Bowl' },
        { id: 'Combine', text: 'Combine' },
        { id: 'Draft', text: 'Draft' },
        { id: 'Kickoff', text: 'Kickoff' },
        { id: 'Other', text: 'Other' }
      ],
      videoMessageUsageLocationOptions: [
        { id: 'Website', text: 'Website' },
        { id: 'Social Media', text: 'Social Media' },
        { id: 'Other Marketing Materials', text: 'Other Marketing Materials' }
      ],
      flatPickerTimeConfig: {
        enableTime: true,
        noCalendar: true,
        dateFormat: 'H:i:S',
        altFormat: 'h:i K',
        altInput: true,
        wrap: true,
        onOpen: (selectedTimes, timeString, flatPickerInstance) => {
          if (selectedTimes.length === 0) {
            flatPickerInstance.setDate('12:00', true)
          }
        }
      },
      redactorOptions: {
        buttons: ['format', 'bold', 'italic', 'lists', 'link'],
        formatting: ['p'],
        formattingAdd: {
          'h4': {
            title: 'Heading',
            api: 'module.block.format',
            args: ['h4']
          },
          'h5': {
            title: 'Subheading',
            api: 'module.block.format',
            args: ['h5']
          }
        }
      },
      initialBookingState: {}
    }
  },

  beforeDestroy () {
    this.clearShortlist()
  },

  watch: {
    '$v.$invalid': function () {
      this.setFormStatus(!this.$v.$invalid)
    },
    'validationTriggered': function () {
      this.$v.$touch()
    },
    complete_by_date (newValue) {
      this.booking.needsConfirmation = {
        status: newValue !== this.initialBookingState.complete_by_date,
        type: this.booking.appearance_type === 'online' ? 'semi-critical' : 'critical'
      }
    },
    date (newValue) {
      this.booking.needsConfirmation = {
        status: newValue !== this.initialBookingState.date,
        type: this.booking.appearance_type === 'online' ? 'semi-critical' : 'critical'
      }
    },
    campaign_id () {
      this.$v.date.$touch()
      this.$v.date2.$touch()
      this.$v.date3.$touch()
      this.$v.complete_by_date.$touch()
      this.$v.commencement_date.$touch()
    },
    budget_per_star (newValue) {
      this.booking.needsConfirmation = {
        status: newValue !== this.initialBookingState.budget_per_star,
        type: 'critical'
      }
    },
    opportunities (newValue, oldValue) {
      let isOffer = (newValue[0].appearance_type !== undefined && newValue[0].appearance_type.match(/(offer)/) !== null)
      this.booking.is_offer = isOffer
      if (isOffer) {
        this.booking.budget_per_star = 0
        this.required_stars = 0
      }
      if (this.booking.currency === 'points' && this.$opportunityPointsModuleEnabled && (this.first === false || oldValue.length === 0)) {
        this.budget_per_star = this.$opportunityPointsModuleSum ? sumBy(this.opportunities, 'points') : maxBy(this.opportunities, item => !isNaN(parseFloat(item.points)) ? parseFloat(item.points) : 0).points
      } else if (this.booking.currency !== 'points' && this.$opportunityBudgetsModuleEnabled && (this.first === false || oldValue.length === 0)) {
        this.budget_per_star = sumBy(this.opportunities, item => !isNaN(parseFloat(item.budget)) ? parseFloat(item.budget) : 0)
      } else if ((this.$opportunityPointsModuleEnabled || this.$opportunityBudgetsModuleEnabled) && newValue.length === 0) {
        this.budget_per_star = 0
      }
      this.first = false
    }
  },

  computed: {
    ...mapState('booking/request', ['formStatus', 'formDirty']),

    selectedCampaignOption () {
      if (this.booking.campaign_id) {
        return this.campaignOptions.find(element => element.id === this.booking.campaign_id)
      }
      return this.booking.campaign
    },

    selectCampaignOptionErrorMessage () {
      if (this.selectedCampaignOption) {
        if (this.selectedCampaignOption.start_date && this.selectedCampaignOption.end_date) {
          return 'Value must be between the dates of the campaign selected.\nPlease choose a date between ' + this.$options.filters.date(this.selectedCampaignOption.start_date, this.$user.date_format_preference) + ' and ' + this.$options.filters.date(this.selectedCampaignOption.end_date, this.$user.date_format_preference)
        }
        if (this.selectedCampaignOption.start_date) {
          return 'Value must be after the start date of the campaign selected.\nPlease choose a date after ' + this.$options.filters.date(this.selectedCampaignOption.start_date, this.$user.date_format_preference)
        }
        if (this.selectedCampaignOption.end_date) {
          return 'Value must be before the end date of the campaign selected.\nPlease choose a date before ' + this.$options.filters.date(this.selectedCampaignOption.end_date, this.$user.date_format_preference)
        }
      }
      return ''
    },

    socialLocationOptions () {
      return [
        {
          id: this.$options.filters.sentenceCase(this.$starLabel) + '(s) profile',
          text: this.$options.filters.sentenceCase(this.$starLabel) + '(s) profile - ' + this.$options.filters.sentenceCase(this.$starLabel) + '(s) will share the content'
        },
        {
          id: 'Our pages',
          text: 'Our pages - We will share the content directly'
        },
        {
          id: 'Both',
          text: 'Both'
        }
      ]
    },

    moneySymbol () {
      const userCurrency = this.$user.region ? this.$user.region.currency_code : this.defaultCurrency
      if (this.booking.currency === 'points' || userCurrency === 'points') {
        return 'Pts'
      }
      return getSymbolFromCurrency(this.booking.currency ? this.booking.currency : userCurrency)
    },
    defaultLatLng () {
      const region = this.regionOptions.find(item => item.id === this.booking.region_id)
      const regionShortname = region ? region.shortname : this.$regionNameAu
      switch (regionShortname) {
        case this.$regionNameUs:
          return {
            lat: 37.0902,
            lng: -95.7129,
            zoom: 3
          }
        case this.$regionNameUk:
          return {
            lat: 55.3781,
            lng: -3.4360,
            zoom: 4
          }
        case this.$regionNameAu:
        default:
          return {
            lat: -25.2744,
            lng: 133.7751,
            zoom: 3
          }
      }
    },

    displayAppearanceType () {
      switch (this.booking.appearance_type) {
        case 'online':
          return 'Online'
        case 'in_person':
          return 'In Person'
        case 'both':
          return 'In Person and Online'
        case 'offer':
          return 'Offer'
        default:
          return '-'
      }
    },

    socialMediaDisclosureLink () {
      switch (this.$user.region.shortname) {
        case 'us':
          return 'https://www.ftc.gov/tips-advice/business-center/guidance/ftcs-endorsement-guides-what-people-are-asking '
        default:
          return 'http://aana.com.au/content/uploads/2018/10/AANA_Clearly-Distinguishable-Advertising_2018-2.pdf'
      }
    },

    googleMapOptions () {
      const usRegion = this.regionOptions.filter(element => element.shortname === this.$regionNameUs)[0]
      const auRegion = this.regionOptions.filter(element => element.shortname === this.$regionNameAu)[0]
      const ukRegion = this.regionOptions.filter(element => element.shortname === this.$regionNameUk)[0]

      const usRegionId = usRegion ? usRegion.id : null
      const auRegionId = auRegion ? auRegion.id : null
      const ukRegionId = ukRegion ? ukRegion.id : null

      switch (this.region_id) {
        case usRegionId:
          return {
            selectFirstOnEnter: true,
            strictBounds: false,
            bounds: {
              north: 49.3457868,
              south: 24.7433195,
              east: -66.9513812,
              west: -124.7844079
            }
          }
        case ukRegionId:
          return {
            selectFirstOnEnter: true,
            strictBounds: false,
            bounds: {
              north: 61.143235,
              south: 48.980217,
              east: 1.933594,
              west: -11.381836
            }
          }
        case auRegionId:
        default:
          return {
            selectFirstOnEnter: true,
            strictBounds: false,
            bounds: {
              north: -9.187026,
              south: -54.833766,
              east: 159.287222,
              west: 110.951034
            }
          }
      }
    },

    /**
     * Flatpickr date config object.
     *
     * Needs to be computed as this is determined by whether or not the user
     * is logged in as an admin.
     *
     * @return object
     */
    flatPickerSingleDateConfig () {
      var userDatePref = 'd/m/Y'
      if (this.$user.date_format_preference === 'month-first') {
        userDatePref = 'M-d-Y'
      }

      return {
        altInput: true,
        altFormat: userDatePref,
        dateFormat: 'Y-m-d',
        wrap: true,
        disable: [
          (date) => {
            if (this.$userIsAdmin) {
              return false
            }

            return moment(date).isBefore(moment().startOf('day'))
          }
        ]
      }
    },

    flatPickerRangeDateConfig () {
      var userDatePref = 'd/m/Y'
      if (this.$user.date_format_preference === 'month-first') {
        userDatePref = 'M-d-Y'
      }

      return {
        altInput: true,
        altFormat: userDatePref,
        dateFormat: 'Y-m-d',
        wrap: true,
        mode: 'range',
        disable: [
          (date) => {
            if (this.$userIsAdmin) {
              return false
            }
            return moment(date).isBefore(moment().startOf('day'))
          }
        ]
      }
    },

    /**
     * Calculate bookings total budget.
     *
     * @return float
     */
    bookingTotalBudget () {
      return this.$v.required_stars.$model * this.$v.budget_per_star.$model
    },
    bookingTotalBudgetWithoutCommission () {
      let bookingTotalBudget = this.$v.required_stars.$model * this.$v.budget_per_star.$model
      if (!bookingTotalBudget) {
        return false
      }
      if (this.$v.commission_dollar.$model) {
        return bookingTotalBudget - (this.$v.commission_dollar.$model * this.$v.required_stars.$model)
      } else if (this.$v.commission_rate.$model) {
        return bookingTotalBudget - (bookingTotalBudget * (this.$v.commission_rate.$model / 100))
      }
      return false
    },
    findAgencyStageText () {
      return this.agencyStageOptions.findIndex(element => element.id === this.booking.agency_stage) !== -1
        ? this.agencyStageOptions.find(element => element.id === this.booking.agency_stage).text
        : ''
    },

    showInPersonBooking () {
      return this.booking.appearance_type === 'in_person' || this.booking.appearance_type === 'both'
    },

    showOnlineBooking () {
      return this.booking.appearance_type === 'online' || this.booking.appearance_type === 'both'
    },

    showDurationField () {
      return this.booking.opportunities.findIndex(item => item.optional_fields.includes('duration') === true) !== -1
    },

    showBudgetAlert () {
      if ((this.$isNflClient) || (!this.booking.id) || (this.booking.currency === 'points')) {
        return false
      }
      return true
    },

    durationFieldLabel () {
      return this.fieldSetSelected('skills_clinic') ? 'Clinic Duration' : 'Speaking Duration'
    },

    showPaidAdvertising () {
      return this.booking.social_post_location === 'Our pages' || this.booking.social_post_location === 'Both'
    },

    otherVideoSelected () {
      return this.booking.video_message_places.findIndex(item => item === 'Other Marketing Materials') !== -1
    },

    displayMarketingDisclaimer () {
      if (this.booking.package_id === 1) {
        return false
      }
      return this.bookingAppearanceOnline
    },

    showCriticalChangeWarnings () {
      return (this.bookingTypeIsBookingRequest && !this.bookingIsVetting && !this.duplicated)
    }
  },

  created () {
    // If forcing it to the billboard we default the "others can apply" state to true.
    if (this.forceBillboard) {
      this.others_can_apply = true
    }

    // Since the date fields do NOT map do date_options
    // we need to pull out the dates from date options and
    // assign them to corresponding model.
    if (this.booking.has_date_options_only) {
      this.booking.date = this.booking.date_options[0]
      this.booking.date2 = this.booking.date_options[1]
      this.booking.date3 = this.booking.date_options[2]
    }

    this.setFormStatus(!this.$v.$invalid)

    const initialBookingState = {
      date: this.booking.date,
      complete_by_date: this.booking.complete_by_date,
      budget_per_star: this.booking.budget_per_star
    }

    this.initialBookingState = initialBookingState
  },

  mounted () {
    let hash = window.location.hash.slice(1)

    if (hash) {
      let target = $(`#${hash}`)

      target.closest('.form-group').addClass('highlight')

      setTimeout(() => {
        $('html, body').animate({
          scrollTop: target.offset().top - 35
        })
      }, 500)
    }
    this.currency = this.defaultCurrency !== 'points' ? this.$user.region.currency_code : 'points'

    this.getRegions().then(response => {
      this.regionOptions = response.data.map(item => {
        return {
          id: item.id,
          text: item.name,
          shortname: item.shortname
        }
      })
      if (!this.region_id) {
        this.region_id = this.$user.region_id
      }
    })
    if (this.$route.query.campaign_id) {
      this.campaign_id = this.$route.query.campaign_id
    }
    if (this.$userIsAdmin && this.$campaigns) {
      this.getCampaigns('', false)
    }
    this.showMap = true

    if (!this.booking.custom_fields) {
      this.getBookingCustomFieldSettings().then(response => {
        this.propertyMutator({
          property: 'custom_fields',
          value: response.data
        })
      })
    }
    if (this.booking) {
      this.description = this.booking.description_formatted ? this.booking.description_formatted : this.booking.description
      this.post_caption = this.booking.post_caption_formatted ? this.booking.post_caption_formatted : this.booking.post_caption
      this.video_caption = this.booking.video_caption_formatted ? this.booking.video_caption_formatted : this.booking.video_caption
      this.ambassadorship_details = this.booking.ambassadorship_details_formatted ? this.booking.ambassadorship_details_formatted : this.booking.ambassadorship_details
    }
  },

  methods: {
    ...mapActions('shortlist', ['clearShortlist']),
    ...mapActions('booking/request', ['setFormStatus', 'setFormDirty', 'resetFormDirty']),
    ...mapActions('region', ['getRegions']),
    ...mapActions('settings', ['getBookingCustomFieldSettings']),

    getCampaigns (keywords, focus = true) {
      return http.get(`campaigns`, { params: { current: this.booking.campaign_id, keywords } }).then(response => {
        const newCampaignOptions = response.data.data.map(item => {
          return {
            id: item.id,
            text: item.name,
            start_date: item.start_date,
            end_date: item.end_date
          }
        })
        this.campaignOptions = newCampaignOptions
        this.campaignPagination = response.data.meta
        if (focus) {
          this.$refs.campaigns.selectize.focus()
        }
      })
    },

    getNextCampaigns (keywords) {
      if (this.campaignPagination && this.campaignPagination.current_page < this.campaignPagination.last_page) {
        return http.get(`campaigns`, { params: { page: this.campaignPagination.current_page + 1, current: this.booking.campaign_id, keywords } }).then(response => {
          const newCampaignOptions = cloneDeep(this.campaignOptions)
          newCampaignOptions.push(...response.data.data.map(item => {
            return {
              id: item.id,
              text: item.name,
              start_date: item.start_date,
              end_date: item.end_date
            }
          }))
          this.campaignOptions = newCampaignOptions
          this.campaignPagination = response.data.meta
        })
      }
      return Promise.resolve()
    },

    updateForm () {
      return this.$v.$touch
    },

    hasErrorClass (field, classes) {
      return field.$error ? `${classes} has-error` : `${classes}`
    },

    getListOptions (list) {
      let listOptionArray = list.split(',')
      return listOptionArray.map(item => {
        return {
          id: item,
          text: item
        }
      })
    },

    /**
     * Handle resetting the address if target input value is empty.
     *
     * @param object event
     *
     * @return void
     */
    handleResetAddressCallback (event) {
      if (event.target.value === null || event.target.value === '') {
        this.establishment = ''
        this.street_address = ''
        this.suburb = ''
        this.postcode = ''
        this.area = ''
        this.state = ''
        this.country = ''
        this.latitude = ''
        this.longitude = ''
      }
    },

    /**
     * Handle the address changing from Google places.
     *
     * Sets the appropriate state for each of the address components.
     *
     * @param object place
     *
     * @return void
     */
    handleAddressChangeCallback (place) {
      let components = {}

      each(place.address_components, component => {
        each(component.types, type => {
          components[type] = component.long_name
        })
      })

      if (place.types.some(type => ['establishment', 'point_of_interest'].indexOf(type) > -1)) {
        this.establishment = place.name || ''
      } else {
        this.establishment = ''
      }

      this.street_address = `${components.street_number || ''} ${components.route || ''}`.trim()
      this.suburb = components.locality || components.postal_town
      this.area = components.country === 'United Kingdom' && components.administrative_area_level_2 !== this.suburb ? components.administrative_area_level_2 : ''
      this.postcode = components.postal_code || ''
      this.state = components.administrative_area_level_1 || ''
      this.country = components.country || ''
      this.latitude = place.geometry.location.lat()
      this.longitude = place.geometry.location.lng()

      if (components.administrative_area_level_1 === 'England') {
        this.state = components.administrative_area_level_2 || components.colloquial_area || components.locality
      }
    }
  }
}
</script>

<style scoped lang="scss">
.event-map {
  margin-bottom: 20px;
}
</style>

<style lang="scss">
  .redactor-editor-wrapper {
    .redactor-editor {
      min-height: 150px !important;
    }
    .redactor-box {
      border: 2px black solid;
    }
  }

  .border-yellow {
    > input {
      border-color: #fcf8e3;
    }
  }
</style>
